import React from "react";
import {decode as base64_decode, encode as base64_encode} from "base-64";
import {Helpers} from "../../config/Helpers";
import {ReactSession} from "react-client-session";
import queryString from "query-string";
//import html2pdf from "html2pdf.js";

class Invoice extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            sessUserCode: (ReactSession.get("sess_usercode")) ? ReactSession.get("sess_usercode") : '',
            orderData: {},
            orderDetailsData: [],
            urlParam: queryString.parse(window.location.search)
        };
    }

    componentDidMount() {
        if (!this.state.sessUserCode) {
            window.location.href = './login?redirectUrl=' + base64_encode(window.location.href);
        } else {
            this.getOrderDetail();
            this.getListOrderDetail();
        }
    }

    getOrderDetail = () => {
        const kodeOrder = (this.state.urlParam.trxid) ? base64_decode(this.state.urlParam.trxid) : '';

        Helpers.getListOrder('no', kodeOrder, '', '', '').then(res => {
            this.setState({ orderData: (res && res[0]) ? res[0] : {} });
        });
    };

    getListOrderDetail = () => {
        const kodeOrder = (this.state.urlParam.trxid) ? base64_decode(this.state.urlParam.trxid) : '';

        Helpers.getListOrderDetail(kodeOrder).then(res => {
            this.setState({ orderDetailsData: res });
        })
    };

    // Tambah prefix "Rp" (nilai dari API sudah berformat, misal "84.000")
    formatRp = (value) => {
        if (value === undefined || value === null || value === '') return '';
        return 'Rp ' + value;
    };

    // Unduh invoice sebagai PDF
    downloadPdf = () => {
        const element = document.getElementById('invoice-box');
        const opt = {
            margin: 10,
            filename: 'Invoice-' + (this.state.orderData.KodeTransaksiOrder || 'waroq') + '.pdf',
            image: { type: 'jpeg', quality: 0.98 },
            html2canvas: { scale: 2, useCORS: true, windowWidth: 1000 },
            jsPDF: { unit: 'mm', format: 'a4', orientation: 'portrait' }
        };
        //html2pdf().set(opt).from(element).save();
    };

    render() {
        return (
            <div className="invoice-page">
                {/* Tombol di luar #invoice-box supaya tidak ikut masuk PDF */}
                <div style={{ textAlign: 'right', maxWidth: 900, margin: '0 auto 12px' }}>
                    <button
                        type="button"
                        className="btn btn-primary"
                        onClick={this.downloadPdf}
                        disabled={!this.state.orderData.KodeTransaksiOrder}
                    >
                        Cetak Invoice (PDF)
                    </button>
                </div>

                <div className="invoice-box" id="invoice-box">
                    <div className="top-row">
                        <div className="logo-box">
                            <img src="/assets/imgs/theme/waroq-logo-2026.png" alt="Logo" />
                        </div>
                        <h1 className="title">INVOICE</h1>
                        <div className="logo-box">
                            <img src="/assets/imgs/theme/waroq-logo-2026.png" alt="Logo" />
                        </div>
                    </div>

                    <div className="header-flex">
                        <div className="from-to">
                            <h3>Invoice From:</h3>
                            <strong>Waroq</strong>

                            <h3 className="mt">Invoice To:</h3>
                            <strong>{this.state.orderData.NamaWarung}</strong>
                            <div>{this.state.orderData.NamaPemilikWarung}</div>
                            <div>{this.state.orderData.Alamat}</div>
                        </div>

                        <table className="meta-table">
                            <tbody>
                            <tr>
                                <td>Invoice #</td>
                                <td>{this.state.orderData.KodeTransaksiOrder}</td>
                            </tr>
                            <tr>
                                <td>Date</td>
                                <td>
                                    {this.state.orderData.date_d} {this.state.orderData.date_m} {this.state.orderData.date_y} {this.state.orderData.date_t}
                                </td>
                            </tr>
                            <tr>
                                <td>Payment Status</td>
                                <td className={
                                    ["LUNAS", "PAID"].includes(String(this.state.orderData.StatusPembayaranLabelNew).toUpperCase())
                                        ? "status-paid" : "status-unpaid"
                                }>
                                    {this.state.orderData.StatusPembayaranLabelNew}
                                </td>
                            </tr>
                            <tr>
                                <td>Order Status</td>
                                <td>{this.state.orderData.new_status_name}</td>
                            </tr>
                            </tbody>
                        </table>
                    </div>

                    <div className="table-scroll">
                        <table className="items">
                            <thead>
                            <tr>
                                <th>#</th>
                                <th>Item</th>
                                <th>Unit</th>
                                <th>Quantity</th>
                                <th>Unit Cost</th>
                                <th>Price</th>
                            </tr>
                            </thead>
                            <tbody>
                            {this.state.orderDetailsData.map((object, i) => (
                                <tr key={object.DetailId || i}>
                                    <td className="text-center">{i + 1}</td>
                                    <td>
                                        <div className="item-desc-1">
                                            <span>{object.NamaBarang}</span>
                                        </div>
                                    </td>
                                    <td className="text-center">{object.UnitBarang}</td>
                                    <td className="text-center">{object.Qty}</td>
                                    <td align="right">{this.formatRp(object.HargaSatuan)}</td>
                                    <td align="right">{this.formatRp(object.Harga)}</td>
                                </tr>
                            ))}
                            </tbody>
                            <tfoot>
                            <tr>
                                <td colSpan="5" align="right">Total Harga</td>
                                <td align="right">{this.formatRp(this.state.orderData.TotalHargaOrder)}</td>
                            </tr>
                            <tr>
                                <td colSpan="5" align="right">Jasa Kirim</td>
                                <td align="right">{this.formatRp(this.state.orderData.JasaKirim)}</td>
                            </tr>
                            <tr>
                                <td colSpan="5" align="right">Biaya Admin</td>
                                <td align="right">{this.formatRp(this.state.orderData.BiayaAdmin)}</td>
                            </tr>
                            <tr>
                                <td colSpan="5" align="right"><strong>Grand Total</strong></td>
                                <td align="right"><strong>{this.formatRp(this.state.orderData.GrandTotal)}</strong></td>
                            </tr>
                            </tfoot>
                        </table>
                    </div>

                    <div className="bottom-flex">
                        <div className="terms">
                            <h3>Terms &amp; Condition</h3>
                            <ol>
                                <li>Isi syarat dan ketentuan di sini.</li>
                            </ol>
                        </div>

                        <div className="payment-info">
                            <h3>Payment Info</h3>
                            <table className="payment-table">
                                <tbody>
                                <tr><td>Metode Pembayaran</td><td>{this.state.orderData.MetodePembayaran}</td></tr>
                                <tr><td>Tipe Pengiriman</td><td>{this.state.orderData.TipePengiriman}</td></tr>
                                <tr><td>Jenis Order</td><td>{this.state.orderData.JenisOrder}</td></tr>
                                <tr><td>Total Item</td><td>{this.state.orderData.TotalItem}</td></tr>
                                </tbody>
                            </table>
                        </div>
                    </div>

                    <div className="generated-note">
                        Invoice generated on: {new Date().toLocaleDateString()}
                    </div>
                </div>  
            </div>
        );
    }
}

export default Invoice;